import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const fade = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 1, ease: [0.22, 1, 0.36, 1] } },
};

export const Story = () => {
  return (
    <section
      id="povestea-mea"
      data-testid="story-section"
      className="relative z-10 py-28 md:py-36 px-6"
    >
      <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="md:col-span-5 relative"
        >
          <div className="absolute -inset-3 rounded-[2rem] bg-[#D6B56D]/10 blur-2xl" />
          <img
            data-testid="story-image"
            src="https://customer-assets.emergentagent.com/job_soul-journey-3d/artifacts/98poio6k_A9B320C2-8CEF-4D3E-B5B4-FB9333E1161D_1_105_c.jpeg"
            alt="We are one"
            className="hidden md:block relative rounded-[2rem] w-full h-[520px] object-cover object-center border border-[#D6B56D]/20"
          />
          <img
            data-testid="story-image-mobile"
            src="https://customer-assets.emergentagent.com/job_soul-journey-3d/artifacts/98poio6k_A9B320C2-8CEF-4D3E-B5B4-FB9333E1161D_1_105_c.jpeg"
            alt="We are one"
            className="md:hidden relative rounded-[2rem] w-full h-[340px] object-cover object-[center_75%] border border-[#D6B56D]/20"
          />
        </motion.div>

        <motion.div
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="md:col-span-7 hero-readable text-outline-strong"
        >
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D6B56D] mb-6">
            My Story
          </p>
          <h2 className="font-heading font-light text-4xl md:text-5xl text-[#EBE4D8] leading-tight mb-8">
            I left to see the world and ended up <span className="italic text-[#D6B56D]">finding myself</span>
          </h2>
          <div className="space-y-5 text-[#EBE4D8] leading-relaxed text-base md:text-lg font-light max-w-xl">
            <p>
              My entire life, I have wanted to touch my identity in its deepest sense. If I existed even a fraction in the deepest realm of existence, I wanted to be conscious of it. To fully answer the most powerful question I know: Who am I?
            </p>
            <p>
              After many failed projects, a bankrupt business, a book written, and a broken heart, at nineteen, I dropped out of college and left Romania. I packed a few things and left without any plan, with my last €20 in my pocket and the promise of a job in eastern Germany.
            </p>
            <p>
              I didn't know it would turn into the journey of my life, but God had a plan for me.
            </p>
          </div>

          <div className="stat-shadow mt-12 flex flex-nowrap justify-between sm:justify-start gap-2 sm:gap-7" data-testid="story-stats">
            {[
              { n: "5", l: "Years" },
              { n: "14", l: "Countries" },
              { n: "200+", l: "Cities" },
              { n: "∞", l: "Lessons" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-heading text-3xl sm:text-5xl text-[#D6B56D]">{s.n}</div>
                <div className="text-[10px] sm:text-sm uppercase tracking-[0.1em] sm:tracking-[0.18em] text-[#EBE4D8] mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex justify-center md:justify-start">
          <Link
            to="/story"
            data-testid="read-more-about-me-button"
            className="group inline-flex items-center gap-3 px-9 py-3.5 rounded-full border border-[#D6B56D]/60 text-[#EBE4D8] text-sm tracking-widest uppercase hover:bg-[#D6B56D]/10 hover:border-[#D6B56D] transition-all duration-300"
          >
            Read more about me
            <ArrowRight
              size={16}
              className="text-[#D6B56D] group-hover:translate-x-1 transition-transform duration-300"
            />
          </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
